import {
  easypostFedexMfaAddressValidationInputSchema,
  easypostFedexMfaAddressValidationOutputSchema,
} from "@redotech/redo-fulfillment-carrier-account-common/easypost-fedex-mfa";

export const easypostFedexMfaAddressValidation = {
  name: "easypostFedexMfaAddressValidation" as const,
  input: easypostFedexMfaAddressValidationInputSchema,
  output: easypostFedexMfaAddressValidationOutputSchema,
};
